module.exports = require('../../full/instance/reduce');
